import React, { useEffect, useContext } from "react";
import { gql, useMutation, TypedDocumentNode } from "@apollo/client";
// import Tour, { ReactourStep } from 'reactour';
import { useTour, TourProvider, StepType } from "@reactour/tour"
import { tours } from "./allTours";
import useRoute from "../../router/useRoute";
import { toast } from "react-toastify";
import { Button } from "semantic-ui-react";
import LoginContext, { ILoginContext } from "../../context/loginContext";
import { IUserGQLType } from "/imports/api/users/interfaces/user";

const SAVE_TOUR_PROGRESS: TypedDocumentNode<
  { res: Pick<IUserGQLType, "preferences"> },
  { input: { tourId: string, step?: number, isDismissed?: Boolean } }
> = gql`
  mutation saveTourProgress ($input: SaveTourProgressInput!) {
    res: saveTourProgress(input: $input) {
      id
      preferences {
        tours {
          tourId
          step
          isDismissed
        }
      }
    }
  }
`;

function userHasNotSeenTour(user: ILoginContext["user"], tourId: string) {
  return !(user.preferences?.tours || []).find((tour) => tour.tourId === tourId);
}

const TourToast = ({ onCloseToast, onConfirm, children }) => {
  return <div>
    {children}
    <Button primary content="yes" onClick={onConfirm} />
    <Button basic content="no" onClick={onCloseToast} />
  </div>
}

export const ReactTour = ({ onDismiss }) => {
  const { user } = useContext(LoginContext);
  const { setIsOpen, setMeta, setSteps } = useTour();
  const { name: routeName } = useRoute();

  function startTour(steps: StepType[], tourId: string) {
    if (!setSteps || !setMeta) return null;
    setSteps(steps);
    setMeta(tourId);
    setIsOpen(true);
  }
  useEffect(() => {
    if (!routeName || !setSteps || !user) return;
    const tourId = routeName as string;
    const tour = tours[routeName];
    if (tour?.steps?.length && userHasNotSeenTour(user, tourId)) {
      toast(<TourToast
        onConfirm={() => {
          startTour([...tour.steps], tourId);
        }}
        onCloseToast={() => { onDismiss(tourId) }}>
        {tour.startTour}
      </TourToast>, {
        toastId: "TOUR_NAG",
        position: "bottom-right",
        autoClose: false,
        hideProgressBar: true
      })

    }
  }, [routeName])

  return null;
}
export default ({ children }) => {
  const [saveTourPreference] = useMutation(SAVE_TOUR_PROGRESS);

  function onClickCloseTour(clickProps) {
    const { meta: tourId, setIsOpen, currentStep, steps } = clickProps;
    saveTourPreference({
      variables: {
        input: {
          tourId,
          step: currentStep,
          isDismissed: (currentStep + 1) < steps?.length
        }
      }
    })
    setIsOpen(false)
  }
  function onDismiss(tourId: string) {
    saveTourPreference({
      variables: {
        input: {
          tourId,
          step: 0,
          isDismissed: true
        }
      }
    })
  }
  return <TourProvider steps={[]} scrollSmooth onClickClose={onClickCloseTour}>
    {children}
    <ReactTour onDismiss={onDismiss} />
  </TourProvider>
}